import httpStatus from 'http-status';
import { FetchUtils } from '~/utils/fetch-utils';

export interface HelpApiParam {
	formSubtype?: string;
}

export class HelpApi {
	public static getHelpFile(
		formName: string,
		params: HelpApiParam,
	): Promise<any> {
		return FetchUtils.get('api/help/:formName/:formSubtype', {
			formName,
			formSubtype:
				params && params.formSubtype ? params.formSubtype : undefined,
		}).then((data: Response) => {
			const contentType: string = data.headers.get('Content-Type');
			if (!contentType) {
				throw new Error(
					'Failed to get Content Type from Help File API response',
				);
			}

			if (
				data.status === httpStatus.MULTIPLE_CHOICES &&
				contentType.includes('text/plain')
			) {
				return data.text();
			} else if (
				data.status === httpStatus.NOT_FOUND &&
				contentType.includes('application/json')
			) {
				return data.json();
			}

			let errorMessage =
				'Failed to get Help File path from API response.';
			if (data.status) {
				errorMessage += ' Unhandled status: ' + data.status + '.';
			}
			if (data.statusText) {
				errorMessage += ' Reason: ' + data.statusText + '.';
			}
			throw new Error(errorMessage);
		});
	}
}
